import React, { useState, useEffect, useCallback, useRef } from "react";
import { useSelector, useDispatch } from 'react-redux'
import { useLocation, useParams, useSearchParams } from "react-router-dom";
import { Skeleton } from "primereact/skeleton";

import "./index.css"
import "../styles/style.css"
import Logo from '../../../images/logo.png';

import _ from "lodash";
import Fuse from 'fuse.js';
import { InputText } from "primereact/inputtext";
import { DataView } from 'primereact/dataview';
import { Dialog } from "primereact/dialog";

import Loading from "../../../common/Loading"
import Product from "./Components/Product";
import Checkout from "./Components/Checkout";
import WishList from "./Components/WishListProduct";
import ProductViewModal from "./Components/ProductViewModal";
import FrequentlyBought from "./Components/FrequentlyBought";

import { getBuyerWishList, updateBuyerWishList } from "../../../services/api/buyerWishList";

import { raiseToast } from '../../../services/redux/reducers/toast/toast';
import { fetchMaterialBrands, fetchMaterialCategories, fetchMaterialUoms } from "../../../services/redux/reducers/commonThunk";
import { getCatalogApiRequestById, updateCatalogApiRequest } from "../../../services/api/SAP";
import { getBuyerRateContractByCompanyIdAndBranchId, getCompanyERPCodeSearch, getFrequentlyBoughtItems } from "../../../services/api/buyerRateContracts";

import { capitalizeWordsInValue, sortArrayOfObjectsInAlphabeticalOrder } from "../../../utils";
import ProductItemSkeleton from "../../../skeletons/ProductItem";
import { getCompanyBranchShipAddrs } from "../../../services/api/companyBranchShipAddr";
import { getCompanyById } from "../../../services/api/company";


const Ariba = () => {
    const { branchId } = useParams()
    const location = useLocation()

    const cartSubmitRef = useRef(null)

    const [searchParams, setSearchParams] = useSearchParams()

    const [selectedShipAddrId, setSelectedShipAddrId] = useState(null)

    const [visibleCheckout, setVisibleCheckout] = useState(false)
    const [isLoaderVisible, setIsLoaderVisible] = useState(true)
    const [isWishListVisible, setIswishListVisible] = useState(false)
    const [isProductViewVisible, setIsProductViewVisible] = useState(false)

    const [searchText, setSearchText] = useState('')
    const [searchBrandText, setSearchBrandText] = useState('')
    const [searchCategoryText, setSearchCategoryText] = useState('')
    const [searchERPCategoryText, setSearchERPCategoryText] = useState('')

    const [company, setCompany] = useState({})
    const [brandToCategoryMap, setBrandToCategoryMap] = useState({})
    const [categoryToBrandMap, setCategoryToBrandMap] = useState({})
    const [ERPcategoryToBrandMap, setERPcategoryToBrandMap] = useState({})
    const [brandToERPCategoryMap, setBrandToERPCategoryMap] = useState({})
    const [catalogApiRequest, setCatalogApiRequest] = useState({})

    const [products, setProducts] = useState([])
    const [cartItems, setCartItems] = useState([])
    const [brands, setBrands] = useState([])
    const [categories, setCategories] = useState([])
    const [ERPCategories, setERPCategories] = useState([])
    const [ERPSubCategories, setERPSubCategories] = useState([])
    const [compERPCategories, setCompERPCategories] = useState([])
    const [compERPSubCategories, setCompERPSubCategories] = useState([])
    const [buyerWishList, setBuyerWishList] = useState([])
    const [viewProductId, setViewProductId] = useState(null)
    const [frequentlyBoughtMaterialIds, setFrequentlyBoughtMaterialIds] = useState([])
    const [shippingAddresses, setShippingAddresses] = useState([])

    const [selectedProducts, setSelectedProducts] = useState([])
    const [selectedBrandIds, setSelectedBrandIds] = useState([])
    const [selectedCategoryIds, setSelectedCategoryIds] = useState([])
    const [selectedERPSubCategoryIds, setSelectedERPSubCategoryIds] = useState([])

    const dispatch = useDispatch()

    const materialUOMs = useSelector((state) => state.common.materialUOMs)
    const materialBrands = useSelector((state) => state.common.materialBrands)
    const materialCategories = useSelector((state) => state.common.materialCategories)
 
    let userId = null

    const useSmartSearch = false // company.tags?.useSmartSearchonRateContract

    useEffect(() => {
        const queryParams = new URLSearchParams(location.search)
        userId = queryParams.get('userId')

        dispatch(fetchMaterialBrands())
        dispatch(fetchMaterialCategories())
        dispatch(fetchMaterialUoms())

        fetchShippingAddresses()
        getBuyerWishListedProducts()
    }, [])

    useEffect(() => {
        if (materialCategories.length && materialUOMs.length && materialBrands.length) {
            getBuyerRateContractCatelogue()
        }
    }, [materialCategories, materialUOMs, materialBrands])

    useEffect(() => {
        if(useSmartSearch){
            handleSmartFuzzySearch()
        } else {
            handleFuzzySearch()
        }
    }, [selectedCategoryIds, selectedBrandIds, selectedERPSubCategoryIds]) //searchText

    useEffect(() => {
        handleBrandFuzzySearch()
    }, [searchBrandText])

    useEffect(() => {
        handleCategoryFuzzySearch()
    }, [searchCategoryText])

    useEffect(() => {
        handleERPCategoryFuzzySearch()
    }, [searchERPCategoryText])

    const clearProductIdOnURL = () => {
        const queryParams = new URLSearchParams(location.search)
        queryParams.delete('prdId')
        const newUrl = `${location.pathname}?${queryParams.toString()}`
        window.history.replaceState({}, '', newUrl)
        setSearchParams(new URLSearchParams(window.location.search))
    }

    const getBuyerCompany = async (companyId) => {
        const companyRes = await getCompanyById(companyId)
        console.log("companyRes", companyRes)
        if (companyRes.failure){
            dispatch(raiseToast({ severity: 'error', detail: companyRes.data.error }))
        }else{
            setCompany(companyRes?.data)
        }
    }

    const fetchShippingAddresses = async () => {
        const shippingAddressessResponse = await getCompanyBranchShipAddrs({branchIds:[branchId], statusIds:[1], paginator: false}) // {branchIds: [branchId]}
        console.log("shippingAddressessResponse", shippingAddressessResponse)
        if(shippingAddressessResponse.failure){
            
        } else {
            setShippingAddresses(shippingAddressessResponse.data.data)
        }
    }

    const getCatalogApiRequest = async (catalogRequestId, modifiedRateContractsList) => {
        if(catalogRequestId){
            setIsLoaderVisible(true)

            const response = await getCatalogApiRequestById(catalogRequestId)
            console.log("getCatalogApiRequestById", response)
            
            if (response.failure) {
                dispatch(raiseToast({ severity: 'error', detail: response.data.error, life: 3000 }))
            } else {
                console.log("getCatalogApiRequestById", response)
                setCatalogApiRequest(response.data)

                if(response.data.shipAddrId){
                    setSelectedShipAddrId(response.data.shipAddrId)
                }

                constructCartItems(response.data, modifiedRateContractsList)
            }
            setIsLoaderVisible(false)
        } else {
            dispatch(raiseToast({ severity: 'error', detail: 'catalog request id not found', life: 3000 }))
        }
    }

    const constructCartItems = async (catalogRequest, modifiedRateContractsList) => {
        if(catalogRequest){
            const updatedCartItems = []
            catalogRequest.cartItems?.map(eachReqItem => {
                const relatedBuyerRateContractProduct = modifiedRateContractsList.find(eachProduct => eachProduct.buyerRateContractId === eachReqItem.buyerRateContractId)

                if(relatedBuyerRateContractProduct){
                    let quantity = relatedBuyerRateContractProduct.companyQtyMultiplier ? eachReqItem.qty * relatedBuyerRateContractProduct.companyQtyMultiplier : eachReqItem.qty
                    updatedCartItems.push({...relatedBuyerRateContractProduct, quantity: quantity})
                }
            })
            console.log("updatedCartItems", updatedCartItems)
            setCartItems(updatedCartItems)            
        } else {
            dispatch(raiseToast({ severity: 'error', detail: 'catalog request id not found', life: 3000 }))
        }
    }

    const fetchFrequentlyBoughtItems = async (companyId) => {
        const frequentlyBuoghtItems = await getFrequentlyBoughtItems(companyId)

        if (frequentlyBuoghtItems.failure) {
            dispatch(raiseToast({ severity: 'error', detail: frequentlyBuoghtItems.data.error, life: 3000 }))
        } else {
            const frequentMaterialIds = frequentlyBuoghtItems.data.map(eachItem => eachItem.materialId)
            setFrequentlyBoughtMaterialIds(frequentMaterialIds)
        }
    }

    const handleFuzzySearch = () => {
        const queryParams = new URLSearchParams(location.search)
        let productId = queryParams.get('prdId')

        let filteredProducts = products

        if(productId){
            filteredProducts = products.filter(eachRCProduct => eachRCProduct.buyerRateContractId === parseInt(productId))
            setSelectedProducts(filteredProducts)
            return
        }

        if(selectedCategoryIds.length > 0){
            filteredProducts = products.filter((product) => selectedCategoryIds.includes(product.categoryId))
        } else {
            filteredProducts = products
        }

        if(selectedBrandIds.length > 0){
            filteredProducts = filteredProducts.filter((product) => selectedBrandIds.includes(product.brandId))
        } else {
            filteredProducts = filteredProducts
        }

        if(selectedERPSubCategoryIds.length > 0){
            filteredProducts = filteredProducts.filter((product) => selectedERPSubCategoryIds.includes(product.ERPSubCategoryId))
        } else {
            filteredProducts = filteredProducts
        }

        if(searchText.length > 0){
            const fuseRC = new Fuse(filteredProducts, {
                keys: ['productString'],
                includeScore: true,
                threshold: 0.3,
                ignoreLocation: true,
                shouldSort: true,
                /*sortFn: (a, b) => {
                    return a.score - b.score;
                },*/
                getFn: (obj) => {
                    return obj.productString.replace(/\s+/g, '')
                }
            })

            const searchResults = fuseRC.search(searchText)
            const relatedProducts = searchResults.map((result) => result.item)
            setSelectedProducts(relatedProducts)
        } else {
            setSelectedProducts(filteredProducts)
        }
    }

    const handleSmartFuzzySearch = () => {
        let filteredProducts = products

        if(selectedCategoryIds.length > 0){
            filteredProducts = products.filter((product) => selectedCategoryIds.includes(product.categoryId))
        } else {
            filteredProducts = products
        }

        if(selectedBrandIds.length > 0){
            filteredProducts = filteredProducts.filter((product) => selectedBrandIds.includes(product.brandId))
        } else {
            filteredProducts = filteredProducts
        }

        if(selectedERPSubCategoryIds.length > 0){
            filteredProducts = filteredProducts.filter((product) => selectedERPSubCategoryIds.includes(product.ERPSubCategoryId))
        } else {
            filteredProducts = filteredProducts
        }

        if(searchText?.length > 0){
            handleSearch()
        } else {
            setSelectedProducts(filteredProducts)
        }
    }

    const handleSearch = async () => {
        clearProductIdOnURL()

        if(!searchText?.trim()){
            setSelectedProducts(products)
            return
        }

        if(!useSmartSearch){
            handleFuzzySearch()
            return
        }

        setIsLoaderVisible(true)

        const queryParams = new URLSearchParams(location.search)
        const companyId = queryParams.get('cmpId')

        const data = {
            companyId: companyId,
            searchText: searchText
        }
        const res = await getCompanyERPCodeSearch(data)

        if(res.failure){
            setSelectedProducts([])
        } else {
            if(res.data){
                let filteredResults = []
                res.data.map(eachObj => {
                    const relatedProduct = products.find(eachProduct => eachProduct.companyERPCodeMapId === eachObj.companyERPCodeMapId)  
                    if(relatedProduct){
                        filteredResults.push(relatedProduct)
                    }
                })

                if(selectedCategoryIds.length > 0){
                    filteredResults = filteredResults.filter((product) => selectedCategoryIds.includes(product.categoryId))
                } else {
                    filteredResults = filteredResults
                }
        
                if(selectedBrandIds.length > 0){
                    filteredResults = filteredResults.filter((product) => selectedBrandIds.includes(product.brandId))
                } else {
                    filteredResults = filteredResults
                }
        
                if(selectedERPSubCategoryIds.length > 0){
                    filteredResults = filteredResults.filter((product) => selectedERPSubCategoryIds.includes(product.ERPSubCategoryId))
                } else {
                    filteredResults = filteredResults
                }

                setSelectedProducts(filteredResults)
            }
        }
        setIsLoaderVisible(false)
    }

    const handleBrandFuzzySearch = () => {
        const brandIds = _.uniqBy(products, "brandId").map(obj => obj.brandId)
        let relatedBrands = []
        materialBrands.map(eachBrand => {
            if (brandIds.includes(eachBrand.brandId)) {
                relatedBrands.push(eachBrand)
            }
        })
        relatedBrands = sortArrayOfObjectsInAlphabeticalOrder(relatedBrands, "brandName")

        if(searchBrandText.length > 0){
            const fuseBrands = new Fuse(relatedBrands, {
                keys: ['brandName'],
                includeScore: true,
                threshold: 0.5,
                ignoreLocation: true,
                shouldSort: true,
                getFn: (obj) => {
                    return obj.brandName.replace(/\s+/g, '')
                }
            })

            const searchResults = fuseBrands.search(searchBrandText)
            const relatedBrandResults = searchResults.map((result) => result.item)
            setBrands(relatedBrandResults)
        } else {
            setBrands(relatedBrands)
        }
    }

    const handleCategoryFuzzySearch = () => {
        const categoryIds = _.uniqBy(products, "categoryId").map(obj => obj.categoryId)
        let relatedCategories = []
        materialCategories.map(eachCategory => {
            if (categoryIds.includes(eachCategory.categoryId)) {
                relatedCategories.push(eachCategory)
            }
        })
        relatedCategories = sortArrayOfObjectsInAlphabeticalOrder(relatedCategories, "categoryName")

        if(searchCategoryText.length > 0){
            const fuseCategories = new Fuse(relatedCategories, {
                keys: ['categoryName'],
                includeScore: true,
                threshold: 0.5,
                ignoreLocation: true,
                shouldSort: true,
                getFn: (obj) => {
                    return obj.categoryName.replace(/\s+/g, '')
                }
            })

            const searchResults = fuseCategories.search(searchCategoryText)
            const relatedCategoryResults = searchResults.map((result) => result.item)
            setCategories(relatedCategoryResults)
        } else {
            setCategories(relatedCategories)
        }
    }

    const handleERPCategoryFuzzySearch = () => {
        if(searchERPCategoryText.length > 0){
            const fuseCategories = new Fuse(compERPCategories, {
                keys: ['categorySearchStr'],
                includeScore: true,
                threshold: 0.5,
                ignoreLocation: true,
                shouldSort: true,
                getFn: (obj) => {
                    return obj.categorySearchStr.replace(/\s+/g, '')
                }
            })

            const searchResults = fuseCategories.search(searchERPCategoryText)
            const relatedCategoryResults = searchResults.map((result) => result.item)
            setERPCategories(relatedCategoryResults)
        } else {
            setERPCategories(compERPCategories)
        }
    }

    const handleSelectCategory = (categoryId) => {
        clearProductIdOnURL()

        const isSelected = selectedCategoryIds.includes(categoryId)

        if (isSelected) {
            setSelectedCategoryIds(prevCategories => prevCategories.filter(id => id !== categoryId))
        } else {
            setSelectedCategoryIds(prevCategories => [...prevCategories, categoryId])
        }
    }

    const handleSelectERPCategory = (ERPCategoryId, isSelected) => {
        clearProductIdOnURL()

        const relatedERPSubCategoryIds = ERPSubCategories.filter(eachERPSubCategory => eachERPSubCategory.ERPCategoryId === ERPCategoryId).map(eachSubCategory => eachSubCategory.ERPSubCategoryId)
        
        if(isSelected){
            const updatedSelectedERPSubCategoryIds = selectedERPSubCategoryIds.filter(eachSubCategoryId => !relatedERPSubCategoryIds.includes(eachSubCategoryId))
            setSelectedERPSubCategoryIds(updatedSelectedERPSubCategoryIds)
        } else {
            const updatedSelectedERPSubCategoryIds = [...new Set([...selectedERPSubCategoryIds, ...relatedERPSubCategoryIds])]
            setSelectedERPSubCategoryIds(updatedSelectedERPSubCategoryIds)
        }
    }

    const handleSelectERPSubCategory = (categoryId) => {
        clearProductIdOnURL()

        const isSelected = selectedERPSubCategoryIds.includes(categoryId)

        if (isSelected) {
            setSelectedERPSubCategoryIds(prevCategories => prevCategories.filter(eachCategoryId => eachCategoryId !== categoryId))
        } else {
            setSelectedERPSubCategoryIds(prevCategories => [...prevCategories, categoryId])
        }
    }

    const handleSelectBrand = (brandId) => {
        clearProductIdOnURL()

        const isSelected = selectedBrandIds.includes(brandId)

        if (isSelected) {
            setSelectedBrandIds(prevBrands => prevBrands.filter(id => id !== brandId))
        } else {
            setSelectedBrandIds(prevBrands => [...prevBrands, brandId])
        }
    }

    const getBuyerRateContractCatelogue = async () => {
        const queryParams = new URLSearchParams(location.search)
        let productId = queryParams.get('prdId')
        let companyId = queryParams.get('cmpId')

        if(!companyId){
            companyId = 81
        }

        const ratecontractParams = {
            companyId: companyId
        }

        if(branchId !== "0"){
            ratecontractParams.branchIds = [0, branchId]
        }

        const response = await getBuyerRateContractByCompanyIdAndBranchId(ratecontractParams) // companyId: companyId, branchIds: [0, branchId] // branchIds: [0, 147]
        console.log("getBuyerRateContractCatelogue response", response)

        if (response.failure) {
            dispatch(raiseToast({ severity: 'error', detail: response.data.error, life: 3000 }))
        } else {

            getBuyerCompany(companyId)
            
            fetchFrequentlyBoughtItems(companyId) 

            const categoryIds = _.uniqBy(response.data, "categoryId").map(obj => obj.categoryId)
            const brandIds = _.uniqBy(response.data, "brandId").map(obj => obj.brandId)

            let companyERPCategories = []
            let companyERPSubCategories = []

            response.data.map(eachProduct => {
                eachProduct.companyERPCategory = eachProduct.companyERPCategory ? eachProduct.companyERPCategory : "Others"
                eachProduct.companyERPSubCategory = eachProduct.companyERPSubCategory ? eachProduct.companyERPSubCategory : "Others"
            })

            response.data.map(eachProduct => {
                const existedERPCategory = companyERPCategories.find(eachERPCategory => eachERPCategory.ERPCategoryName === eachProduct.companyERPCategory)
                if(!existedERPCategory){
                    companyERPCategories.push({
                        ERPCategoryId: companyERPCategories.length + 1,
                        ERPCategoryName: eachProduct.companyERPCategory,
                        categorySearchStr: eachProduct.companyERPCategory
                    })
                }
            })

            console.log("companyERPCategories", companyERPCategories)

            response.data.map(eachProduct => {
                const relatedERPCategory = companyERPCategories.find(eachERPCategory => eachERPCategory.ERPCategoryName === eachProduct.companyERPCategory)
                const existedERPSubCategory = companyERPSubCategories.find(eachERPSubCategory => eachERPSubCategory.ERPCategoryId === relatedERPCategory.ERPCategoryId && eachERPSubCategory.ERPSubCategoryName === eachProduct.companyERPSubCategory)
                if(!existedERPSubCategory){
                    companyERPSubCategories.push({
                        ERPSubCategoryId: companyERPSubCategories.length + 1,
                        ERPSubCategoryName: eachProduct.companyERPSubCategory,
                        ERPCategoryId: relatedERPCategory.ERPCategoryId
                    })
                    relatedERPCategory.categorySearchStr += " " + eachProduct.companyERPSubCategory
                }
            })

            companyERPCategories = sortArrayOfObjectsInAlphabeticalOrder(companyERPCategories, "ERPCategoryName")
            companyERPSubCategories = sortArrayOfObjectsInAlphabeticalOrder(companyERPSubCategories, "ERPSubCategoryName")


            const modifiedRateContractsList = response.data.map(eachProduct => {
                const erpCode = eachProduct.companyERPCode ? `${eachProduct.companyERPCode} |` : ''
                const productString = `${eachProduct?.materialId} | ${erpCode} ${eachProduct?.companyProdName} | ${eachProduct?.companyProdSpec}`

                const relatedUOM = materialUOMs?.find(eachUOM => {
                    return eachUOM.UOM === eachProduct.companyERPUOM
                })

                const relatedMaterialCategory = materialCategories?.find(eachCategory => {
                    return eachCategory.categoryId === eachProduct.categoryId
                })

                const relatedERPCategory = companyERPCategories.find(eachERPCategory => eachERPCategory.ERPCategoryName === eachProduct.companyERPCategory)
                const relatedERPSubCategory = companyERPSubCategories.find(eachERPSubCategory => eachERPSubCategory.ERPCategoryId === relatedERPCategory.ERPCategoryId && eachERPSubCategory.ERPSubCategoryName === eachProduct.companyERPSubCategory)

                return {
                    ...eachProduct, 
                    productString, 
                    materialUOMId: relatedUOM?.materialUOMId, 
                    categoryName: relatedMaterialCategory?.categoryName,
                    ERPCategoryId: relatedERPCategory.ERPCategoryId,
                    ERPSubCategoryId: relatedERPSubCategory.ERPSubCategoryId
                }
            })
            
            setProducts(modifiedRateContractsList)
            let updatedSelectedProducts = modifiedRateContractsList
            if(productId){
                updatedSelectedProducts = modifiedRateContractsList.filter(eachRCProduct => eachRCProduct.buyerRateContractId === parseInt(productId))
                if(updatedSelectedProducts.length > 0){
                    setSearchText(updatedSelectedProducts[0].companyProdSpec)
                }
            }
            setSelectedProducts(updatedSelectedProducts)

            let categoryToBrandMap = {}
            let brandToCategoryMap = {}
            let ERPcategoryToBrandMap = {}
            let brandToERPCategoryMap = {}

            const companyERPSubCategoryIds = companyERPSubCategories.map(eachERPSubCategory => eachERPSubCategory.ERPSubCategoryId)

            let relatedCategories = []
            materialCategories.map(eachCategory => {
                if (categoryIds.includes(eachCategory.categoryId)) {
                    let relatedBrandIds = []
                    modifiedRateContractsList.map(eachProduct => {
                        if (eachProduct.categoryId === eachCategory.categoryId){
                            relatedBrandIds.push(eachProduct.brandId)
                        }
                    })
                    if (categoryToBrandMap[eachCategory.categoryId]){
                        categoryToBrandMap[eachCategory.categoryId] = [...categoryToBrandMap[eachCategory.categoryId], ...relatedBrandIds]
                    }else {
                        categoryToBrandMap[eachCategory.categoryId] = [...relatedBrandIds]
                    }
                    relatedCategories.push(eachCategory)
                }
            })
            relatedCategories = sortArrayOfObjectsInAlphabeticalOrder(relatedCategories, "categoryName")

            setCategories(relatedCategories)
            setCategoryToBrandMap(categoryToBrandMap)
            setERPcategoryToBrandMap(ERPcategoryToBrandMap)

            companyERPSubCategories.map(eachCategory => {
                if (companyERPSubCategoryIds.includes(eachCategory.ERPSubCategoryId)) {
                    let relatedBrandIds = []
                    modifiedRateContractsList.map(eachProduct => {
                        if (eachProduct.ERPSubCategoryId === eachCategory.ERPSubCategoryId){
                            if(!relatedBrandIds.includes(eachProduct.brandId)){
                                relatedBrandIds.push(eachProduct.brandId)
                            }
                        }
                    })
                    if (ERPcategoryToBrandMap[eachCategory.ERPSubCategoryId]){
                        ERPcategoryToBrandMap[eachCategory.ERPSubCategoryId] = [...ERPcategoryToBrandMap[eachCategory.ERPSubCategoryId], ...relatedBrandIds]
                    }else {
                        ERPcategoryToBrandMap[eachCategory.ERPSubCategoryId] = [...relatedBrandIds]
                    }
                }
            })

            let relatedBrands = []
            materialBrands.map(eachBrand => {
                if (brandIds.includes(eachBrand.brandId)) {
                    let relatedCategoryIds = []
                    modifiedRateContractsList.map(eachProduct => {
                        if (eachProduct.brandId === eachBrand.brandId){
                            relatedCategoryIds.push(eachProduct.categoryId)
                        }
                    })
                    if (brandToCategoryMap[eachBrand.brandId]){
                        brandToCategoryMap[eachBrand.brandId] = [...brandToCategoryMap[eachBrand.brandId], ...relatedCategoryIds]
                    }else {
                        brandToCategoryMap[eachBrand.brandId] = [...relatedCategoryIds]
                    }
                    relatedBrands.push(eachBrand)
                }
            })
            relatedBrands = sortArrayOfObjectsInAlphabeticalOrder(relatedBrands, "brandName")

            materialBrands.map(eachBrand => {
                if (brandIds.includes(eachBrand.brandId)) {
                    let relatedCategoryIds = []
                    modifiedRateContractsList.map(eachProduct => {
                        if (eachProduct.brandId === eachBrand.brandId){
                            relatedCategoryIds.push(eachProduct.ERPSubCategoryId)
                        }
                    })
                    if (brandToERPCategoryMap[eachBrand.brandId]){
                        brandToERPCategoryMap[eachBrand.brandId] = [...brandToERPCategoryMap[eachBrand.brandId], ...relatedCategoryIds]
                    }else {
                        brandToERPCategoryMap[eachBrand.brandId] = [...relatedCategoryIds]
                    }
                }
            })

            setBrands(relatedBrands)
            setBrandToCategoryMap(brandToCategoryMap)
            setBrandToERPCategoryMap(brandToERPCategoryMap)

            setERPCategories(companyERPCategories)
            setCompERPCategories(companyERPCategories)
            setERPSubCategories(companyERPSubCategories)
            setCompERPSubCategories(companyERPSubCategories)

            const queryParams = new URLSearchParams(location.search)
            const catalogRequestId = queryParams.get('reqId')
            getCatalogApiRequest(catalogRequestId, modifiedRateContractsList)
        }
        setIsLoaderVisible(false)
    }

    const getBuyerWishListedProducts = async () => {
        const queryParams = new URLSearchParams(location.search)
        const userId = queryParams.get('userId')
        const companyId = queryParams.get('cmpId')

        const buyerWishListRes = await getBuyerWishList({userIds: [userId], companyIds: [companyId]})
        console.log("buyerWishListRes", buyerWishListRes)
        if (buyerWishListRes.failure){
            return dispatch(raiseToast({ severity: 'error', summary: 'Buyer Wish List', detail: buyerWishListRes.data.error, life: 3000 }))
        }

        setBuyerWishList(buyerWishListRes.data.data)
    }

    const updateCartItems = (updateType, selectedItem) => {
        let updatedCartItems = []

        if(updateType === "CLEAR"){
            updatedCartItems = []
        }
        else if(updateType === "ADD"){
            updatedCartItems = [...cartItems, { ...selectedItem, quantity: 1 }]
        }
        else if(updateType === "CHANGE"){
            updatedCartItems = cartItems.map(eachCartItem => {
                if (eachCartItem.buyerRateContractId === selectedItem.buyerRateContractId) {
                    return { ...selectedItem }
                }
                return eachCartItem
            })
        }
        else if(updateType === "INCREASE"){
            updatedCartItems = cartItems.map(eachCartItem => {
                if (eachCartItem.buyerRateContractId === selectedItem.buyerRateContractId) {
                    eachCartItem.quantity += 1
                }
                return eachCartItem
            })
        }
        else if(updateType === "DECREASE"){
            updatedCartItems = cartItems.map(eachCartItem => {
                if (eachCartItem.buyerRateContractId === selectedItem.buyerRateContractId) {
                    if (eachCartItem.quantity >= 1) {
                        eachCartItem.quantity -= 1
                    }
                }
                return eachCartItem
            })
        }
        else if(updateType === "REMOVE"){
            updatedCartItems = cartItems.filter(prod => prod.buyerRateContractId !== selectedItem.buyerRateContractId)
        }
        else if(updateType === "SET"){
            updatedCartItems = cartItems.map(eachCartItem => {
                if(eachCartItem.buyerRateContractId === selectedItem.buyerRateContractId) {
                    if(eachCartItem.quantity && eachCartItem.quantity !== "" && parseInt(eachCartItem.quantity) !== 0){
                        eachCartItem.quantity = parseFloat(eachCartItem.quantity)
                        return eachCartItem
                    } else {
                        eachCartItem.quantity = 0
                    }
                }
                return eachCartItem
            })
        }
        updatedCartItems = updatedCartItems.filter(eachCartItem => eachCartItem.quantity > 0)
        setCartItems(updatedCartItems)
    }

    const handleUpdateBuyerWishList = useCallback(_.debounce(async function(updatedBuyerWishList) {
        const buyerWishListResponse = await updateBuyerWishList(updatedBuyerWishList)

        if(buyerWishListResponse.failure){
            return dispatch(raiseToast({ severity: 'error', summary: 'Update Buyer Wish List', detail: buyerWishListResponse.data.error, life: 3000 }))
        } else {
            const buyerWishList = buyerWishListResponse.data
            setBuyerWishList(buyerWishList)
        }
    }, 2000), [])

    const handleWishListChange = (buyerRateContractId) => {
        const queryParams = new URLSearchParams(location.search)
        const userId = queryParams.get('userId')
        const companyId = queryParams.get('cmpId')

        let updatedBuyerWishList = []

        let relatedBuyerWishList = buyerWishList.find(eachBuyerWishList => eachBuyerWishList.buyerRateContractId === buyerRateContractId)

        if (relatedBuyerWishList){
            updatedBuyerWishList = buyerWishList.map(eachBuyerWishList => {
                if (eachBuyerWishList.buyerRateContractId === buyerRateContractId){
                    return {...eachBuyerWishList, statusId: 2}
                }

                return eachBuyerWishList
            })
        }else{
            let newBuyerWishList = {
                companyId: companyId,
                buyerRateContractId: buyerRateContractId,
                statusId: 1,
                updatedBy: userId,
                updatedAt: new Date()
            }

            updatedBuyerWishList = [...buyerWishList, newBuyerWishList]
        }

        if(!relatedBuyerWishList){
            dispatch(raiseToast({ severity: 'success', summary: "Wishlist", detail: "Added to wishlist" }))
        }

        setBuyerWishList(updatedBuyerWishList)
        handleUpdateBuyerWishList(updatedBuyerWishList)
    }

    const handleSubmit = async (event) => {
        event.preventDefault()

        if (cartItems.length == 0) {
            return dispatch(raiseToast({ severity: 'warn', detail: "Add products to cart", life: 3000 }))
        }

        if(!selectedShipAddrId){
            return dispatch(raiseToast({ severity: 'warn', detail: "PLease select shipping address" }))
        }

        let totalPrice = 0
        let productItemsWithERPCode = []

        cartItems.map((product) => {
            totalPrice = totalPrice + product.unitPrice
            if (product.companyERPCodeMap?.companyERPCode) {

                const erpCode = product.companyERPCodeMap.companyERPCode
                if (erpCode) {
                    productItemsWithERPCode.push(erpCode)
                }
            }
        })

        const queryParams = new URLSearchParams(location.search)
        const userIdParam = queryParams.get('userId')
        const companyId = queryParams.get('cmpId')

        /*const data = {
            orderDetails: {
                pmCompanyId: 1,
                orderTypeId: 2,
                companyId: companyId ? companyId : null,
                branchId: branchId,
                gstinId: '11eafd03-e234-48b4-9fbb-c702e2661dd5',
                userId: userIdParam,
                shipAddrId: catalogApiRequest.shipAddrId,
                //shipAddrId: 204,
                //billAddrId: 111,
                isRouted: false,
                totalAmount: totalPrice,
                catalogAPIReqId: catalogApiRequest.catalogApiRequestId
            },
            productItems: {
                productItemsWithErpCode: productItemsWithERPCode,
                productItemsWithoutErpCode: []
            },
            cartItems: cartItems
        }*/

        const newAribaReqItems = []
        cartItems.map(eachCartItem => {
            newAribaReqItems.push({
                buyerRateContractId: eachCartItem.buyerRateContractId,
                qty: eachCartItem.quantity,
                statusId: 1,
                materialId: eachCartItem.materialId,
                companyQtyMultiplier: eachCartItem.companyQtyMultiplier,
                buyerRateContractId: eachCartItem.buyerRateContractId,
                companyERPCode: eachCartItem.companyERPCode,
                companyERPCodeMapId: eachCartItem.companyERPCodeMapId,
                HSNCode: eachCartItem.HSNCode,
                companyHSNOverride: eachCartItem.companyHSNOverride,
                companyGSTOverride: eachCartItem.companyGSTOverride,
                leadTime: eachCartItem.leadTime,
                unitPrice: eachCartItem.unitPrice
            })
        })
        
        try{
            let newShipAddrId = null 
            if(selectedShipAddrId && catalogApiRequest.shipAddrId !== selectedShipAddrId){
                newShipAddrId = selectedShipAddrId
            }

            const data = {
                cartItems: newAribaReqItems
            }

            if(newShipAddrId){
                data.shipAddrId = newShipAddrId
            }

            const addCatelogue = await updateCatalogApiRequest(catalogApiRequest.catalogApiRequestId, data)
            console.log("addCatelogue", addCatelogue)

            if (addCatelogue?.data?.catalogApiRequestId) {
                setIsLoaderVisible(false)
                setVisibleCheckout(false)
                dispatch(raiseToast({ severity: 'success', detail: 'Products added Successfully!', life: 3000 }))

                cartSubmitRef.current.click()
            }
            else {
                dispatch(raiseToast({ severity: 'error', detail: 'Order submission failed!', life: 3000 }))
                setIsLoaderVisible(false)
            }
        } catch(err){
            console.log("addCatelogue: error", err)
        }
    }

    const handleViewProduct = (selectedRateContractId) => {
        setViewProductId(selectedRateContractId)
        setIsProductViewVisible(true)
    }

    const itemTemplate = (product) => {
        return (
            <Product
                product={product} 
                company={company}
                cartItems={cartItems}
                materialBrands={materialBrands}
                materialCategories={materialCategories}
                setCartItems={setCartItems}
                updateCartItems={updateCartItems}
                handleWishListChange={handleWishListChange}
                buyerWishList={buyerWishList}
                handleViewProduct={handleViewProduct}
            />
        )
    }

    const renderProductsSkeleton = () => {
        return (
            <div className="flex" style={{flexWrap: "wrap", justifyContent: "space-evenly"}} >
                <ProductItemSkeleton />
                <ProductItemSkeleton />
                <ProductItemSkeleton />
                <ProductItemSkeleton />
                <ProductItemSkeleton />
                <ProductItemSkeleton />
                <ProductItemSkeleton />
                <ProductItemSkeleton />
                <ProductItemSkeleton />
                <ProductItemSkeleton />
                <ProductItemSkeleton />
                <ProductItemSkeleton />
            </div>
        )
    }

    const renderFilterSkeleton = () => {
        return (
            <div className="flex" style={{flexWrap: "wrap", justifyContent: "space-evenly"}} >
                <Skeleton width="10rem" className="mb-2" />
                <Skeleton width="10rem" className="mb-2" />
                <Skeleton width="10rem" className="mb-2" />
                <Skeleton width="10rem" className="mb-2" />
                <Skeleton width="10rem" className="mb-2" />
                <Skeleton width="10rem" className="mb-2" />
                <Skeleton width="10rem" className="mb-2" />
            </div>
        )
    }

    const handleSearchKeyPress = (event) => {
        if (event.key === 'Enter') {
            handleSearch()
        }
    }

    const renderCheckOutHeader = () => {
        return (
            <div className="flex flex-row justify-content-between py-1">
                <h5 className="m-2 font-bold">Shopping Cart</h5>
                <h5 className="m-2 font-bold">({cartItems.length} Items)</h5>
            </div>
        )
    }

    const displayProducts = selectedProducts.map(eachProduct => {
        const relatedCartItem = cartItems.find(prod => {
            return prod.buyerRateContractId == eachProduct.buyerRateContractId
        })
        return {
            eachProduct: eachProduct,
            relatedCartItem: relatedCartItem
        }
    })

    let selectedCategories = []
    let unSelectedCategories = []

    categories.map(eachCategory => {
        let relatedProducts = products.filter(eachProduct => {
            if (eachCategory.categoryId === eachProduct.categoryId){
                if (selectedBrandIds.length){
                    return selectedBrandIds.includes(eachProduct.brandId)
                }
                return eachProduct
            }
        })
        if (selectedCategoryIds.includes(eachCategory.categoryId)){
            selectedCategories.push({...eachCategory, totalItems: relatedProducts.length})
        }
        if (!selectedCategoryIds.includes(eachCategory.categoryId)){
            unSelectedCategories.push({...eachCategory, totalItems: relatedProducts.length})
        }
    })

    let updatedCategories = [...selectedCategories, ...unSelectedCategories]

    if (selectedBrandIds.length){
        let requiredCategoryIds = []
        selectedBrandIds.map(eachBrandId => {
            let relatedCategoryIds = brandToCategoryMap[eachBrandId]
            requiredCategoryIds.push(...relatedCategoryIds)
        })
        updatedCategories = updatedCategories.filter(eachCategory => requiredCategoryIds.includes(eachCategory.categoryId))
    }
    updatedCategories = updatedCategories.filter(eachCategory => eachCategory.totalItems > 0)

    
    let selectedERPSubCategories = []
    let unSelectedERPSubCategories = []

    ERPSubCategories.map(eachCategory => {
        let relatedProducts = products.filter(eachProduct => {
            if (eachCategory.ERPSubCategoryId === eachProduct.ERPSubCategoryId){
                if (selectedBrandIds.length){
                    return selectedBrandIds.includes(eachProduct.brandId)
                }
                return eachProduct
            }
        })
        if (selectedERPSubCategoryIds.includes(eachCategory.ERPSubCategoryId)){
            selectedERPSubCategories.push({...eachCategory, totalItems: relatedProducts.length})
        }
        if (!selectedERPSubCategoryIds.includes(eachCategory.ERPSubCategoryId)){
            unSelectedERPSubCategories.push({...eachCategory, totalItems: relatedProducts.length})
        }
    })

    let updatedERPSubCategories = [...selectedERPSubCategories, ...unSelectedERPSubCategories]

    if (selectedBrandIds.length){
        let requiredCategoryIds = []
        selectedBrandIds.map(eachBrandId => {
            let relatedCategoryIds = brandToERPCategoryMap[eachBrandId]
            requiredCategoryIds.push(...relatedCategoryIds)
        })
        updatedERPSubCategories = updatedERPSubCategories.filter(eachCategory => requiredCategoryIds.includes(eachCategory.ERPSubCategoryId))
    }
    updatedERPSubCategories = updatedERPSubCategories.filter(eachCategory => eachCategory.totalItems > 0)


    let selectedBrands = []
    let unSelectedBrands = []

    brands.map(eachBrand => {
        let relatedProducts = products.filter(eachProduct => {
            if (eachProduct.brandId === eachBrand.brandId){
                if (selectedCategoryIds.length){
                    return selectedCategoryIds.includes(eachProduct.categoryId)
                }

                return eachProduct
            }
        })
        if (selectedBrandIds.includes(eachBrand.brandId)){
            selectedBrands.push({...eachBrand, totalItems: relatedProducts.length})
        }
        if (!selectedBrandIds.includes(eachBrand.brandId)){
            unSelectedBrands.push({...eachBrand, totalItems: relatedProducts.length})
        }
    })

    let updatedBrands = [...selectedBrands, ...unSelectedBrands]

    if (selectedCategoryIds.length){
        let requiredBrandIds = []
        selectedCategoryIds.map(eachCategoryId => {
            let relatedBrandIds = categoryToBrandMap[eachCategoryId]
            requiredBrandIds.push(...relatedBrandIds)
        })
        updatedBrands = updatedBrands.filter(eachBrand => requiredBrandIds.includes(eachBrand.brandId))
    }
    updatedBrands = updatedBrands.filter(eachBrand => eachBrand.totalItems > 0)

    console.log("company?.tags", company)

    if(company?.tags?.useERPCategoryFilterOnBRCP){
        selectedBrands = []
        unSelectedBrands = []

        updatedBrands.map(eachBrand => {
            let relatedProducts = products.filter(eachProduct => {
                if (eachProduct.brandId === eachBrand.brandId){
                    if (selectedERPSubCategoryIds.length){
                        return selectedERPSubCategoryIds.includes(eachProduct.ERPSubCategoryId)
                    }

                    return eachProduct
                }
            })
            if (selectedBrandIds.includes(eachBrand.brandId)){
                selectedBrands.push({...eachBrand, totalItems: relatedProducts.length})
            }
            if (!selectedBrandIds.includes(eachBrand.brandId)){
                unSelectedBrands.push({...eachBrand, totalItems: relatedProducts.length})
            }
        })

        updatedBrands = [...selectedBrands, ...unSelectedBrands]


        if (selectedERPSubCategoryIds.length){
            let requiredBrandIds = []
            selectedERPSubCategoryIds.map(eachCategoryId => {
                let relatedBrandIds = ERPcategoryToBrandMap[eachCategoryId]
                requiredBrandIds.push(...relatedBrandIds)
            })
            updatedBrands = updatedBrands.filter(eachBrand => requiredBrandIds.includes(eachBrand.brandId))
        }
        updatedBrands = updatedBrands.filter(eachBrand => eachBrand.totalItems > 0)
    }

    const updatedERPCategoryIds = updatedERPSubCategories.map(eachERPSubCategory => eachERPSubCategory.ERPSubCategoryId)
    let updatedERPCategories = ERPCategories.filter(eachERPCategory => updatedERPCategoryIds.includes(eachERPCategory.ERPCategoryId))

    const selectedERPCategories = []
    const unSelectedERPCategories = []

    updatedERPCategories.map(eachCategory => {
        const relatedSubCategories = updatedERPSubCategories.filter(eachSubCategory => eachSubCategory.ERPCategoryId === eachCategory.ERPCategoryId)
        const relatedSubCategoryIds = relatedSubCategories.map(eachSubCategory => eachSubCategory.ERPSubCategoryId)

        const isSubCategorySelected = relatedSubCategoryIds.some(eachSubCategoryId => selectedERPSubCategoryIds.includes(eachSubCategoryId))
        if(isSubCategorySelected){
            selectedERPCategories.push(eachCategory)
        } else {
            unSelectedERPCategories.push(eachCategory)
        }
    })
    updatedERPCategories = [...selectedERPCategories, ...unSelectedERPCategories]

    let activeBuyerWishList = buyerWishList.filter(eachBuyerWishList => eachBuyerWishList.statusId === 1)

    return (
        <>
            <div className="catalogue-request-layout" style={{marginTop:"-30px", padding: "0 6%"}}>
                <div className="h-3rem flex flex-row justify-content-between mb-4 mt-2">
                    <div className="logo me-lg-5 me-3">
                        <img src={Logo} alt="" style={{ height: '35px', marginTop: '4px' }} />
                    </div>
                    <div className="catalogue-request-search w-5 p-input-icon-right">
                        <div className="flex flex-row justify-content-center align-items-center" onClick={handleSearch} style={{cursor: "pointer", position: "absolute", width: "50px", height: "45px", right: 0, backgroundColor: "#ffa53b", borderTopRightRadius: "6px", borderBottomRightRadius: "6px"}}>
                            <i className="pi pi-search" style={{color: "white", fontSize: "17px", marginTop: "3px"}} />
                        </div>
                        <InputText placeholder="I'm searching for..." value={searchText} style={{ width: "100%", height: "45px", fontSize: "16px", borderColor: "#ececec" }} onChange={(e) => setSearchText(e.target.value)} onKeyDown={handleSearchKeyPress} />
                    </div>
                    <div>
                        <div className="right-side-menu flex flex-row mt-2">
                            <div className="right-side header-badge" style={{marginRight: "20px"}}>
                                <button  onClick={() => { setIswishListVisible(true) }} type="button" className="btn p-0 position-relative header-wishlist">
                                    <i className="pi pi-heart" style={{ fontSize: '1.5rem', cursor: 'pointer' }} ></i>
                                    <div className="wishlist-count">
                                        {activeBuyerWishList.length}
                                    </div>
                                </button>
                            </div>
                            { true ?
                                <div className="right-side">
                                    <div className="onhover-dropdown header-badge" style={{borderLeft: "1px solid black", paddingLeft: "10px"}}>
                                        <button label={`VIEW CART (${(cartItems.length)})`} onClick={() => setVisibleCheckout(true)} type="button" className="btn p-0 position-relative header-wishlist">
                                            <i className="pi pi-shopping-cart" style={{ fontSize: '1.5rem' }}></i>
                                            <div className="cart-count">
                                                {cartItems.length}
                                            </div>
                                        </button>
                                    </div>
                                </div> : ""
                            }
                        </div>
                    </div>
                </div>

                <FrequentlyBought 
                    products={products}
                    frequentlyBoughtMaterialIds={frequentlyBoughtMaterialIds}
                    materialBrands={materialBrands}
                    handleViewProduct={handleViewProduct}
                    minimumLength={3}
                />

                <div className="catalogue-request-container">
                    <div className="accordion custom-accordion mt-4 col-2" style={{ width: "250px", paddingRight: "20px" }} id="accordionExample">
                        
                        { company?.tags?.useERPCategoryFilterOnBRCP && 
                            <div className="accordion-item" style={{ display: "flex", flexDirection: "column", justifyContent: "left" }}>
                                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "11px" }}>
                                    <h2 className="accordion-header" id="panelsStayOpen-headingOne" style={{ color: "#222", fontSize: "18px", borderBottom: "2px solid #0da487", paddingBottom: "6px" }}>
                                        Categories
                                    </h2>
                                    <i className="pi pi-angle-down" style={{ fontSize: '1rem' }}></i>
                                </div>

                                <div id="collapseOne" className="accordion-collapse collapse show">
                                    <div className="accordion-body">
                                        <div className="form-floating theme-form-floating-2 search-box" style={{ position: "relative", display: "flex", justifyContent: "center" }}>
                                            <input style={{ width: "100%", border: "1px solid #ced4da", borderRadius: "0.25rem" }} type="search" className="form-control" id="search"
                                                placeholder="Search" value={searchERPCategoryText} onChange={(e) => setSearchERPCategoryText(e.target.value)}/>

                                            <div style={{ cursor: "pointer", position: "absolute", left: "86%", top: "0.9rem" }} >
                                                <i className="pi pi-search" style={{ fontSize: '1rem' }}></i> 
                                            </div>
                                        </div>
                                        {
                                            selectedERPSubCategoryIds.length ? <div className="mt-3" style={{cursor: 'pointer', color: 'rgb(76 140 128)', fontSize: "14px"}} onClick={() => setSelectedERPSubCategoryIds([])}>Clear All</div> : null
                                        }
                                        <ul className="category-list custom-padding custom-height pt-1">
                                            {
                                                isLoaderVisible ? 
                                                    renderFilterSkeleton()
                                                :
                                                updatedERPCategories.map(eachCategory => {
                                                    const relatedSubCategories = updatedERPSubCategories.filter(eachSubCategory => eachSubCategory.ERPCategoryId === eachCategory.ERPCategoryId)
                                                    const relatedSubCategoryIds = relatedSubCategories.map(eachSubCategory => eachSubCategory.ERPSubCategoryId)

                                                    let displaySubCategories = true 

                                                    if(relatedSubCategories.length === 1 && relatedSubCategories[0].ERPSubCategoryName === "Others"){
                                                        displaySubCategories = false
                                                    }
                                                    const allSubCategoriesSelected = relatedSubCategoryIds.every(eachSubCategoryId => selectedERPSubCategoryIds.includes(eachSubCategoryId))
                                                    const isSubCategorySelected = relatedSubCategoryIds.some(eachSubCategoryId => selectedERPSubCategoryIds.includes(eachSubCategoryId))
                                                    const totalERPCategoryItems = _.sumBy(relatedSubCategories, 'totalItems')

                                                    return (
                                                        <li style={{marginBottom: "0.2rem"}} key={`rc-pm-category-filter-${eachCategory.ERPCategoryName}`} >
                                                            <div className="form-check ps-0 m-0 category-list-box">
                                                                <input className="checkbox_animated" type="checkbox" id="fruit" onClick={() => handleSelectERPCategory(eachCategory.ERPCategoryId, allSubCategoriesSelected)} checked={isSubCategorySelected}/>
                                                                <label className="form-check-label" htmlFor="fruit">
                                                                    <span className="name">{capitalizeWordsInValue(eachCategory.ERPCategoryName)}</span>
                                                                    <span className="number">({totalERPCategoryItems})</span>
                                                                </label>
                                                            </div>
                                                            { displaySubCategories &&
                                                                <ul className="ml-4 mt-1 custom-height pt-1" >
                                                                    {
                                                                        relatedSubCategories.map(eachSubCategory => {
                                                                            return (
                                                                                <li key={`rc-pm-category-filter-${eachSubCategory.ERPSubCategoryId}`} >
                                                                                    <div className="form-check ps-0 m-0 category-list-box" style={{paddingBottom: "6px"}}>
                                                                                        <input className="checkbox_animated" type="checkbox" id="fruit" onClick={() => handleSelectERPSubCategory(eachSubCategory.ERPSubCategoryId)} checked={selectedERPSubCategoryIds.includes(eachSubCategory.ERPSubCategoryId)}/>
                                                                                        <label className="form-check-label" htmlFor="fruit">
                                                                                            <span className="name sub-name">{capitalizeWordsInValue(eachSubCategory.ERPSubCategoryName)}</span>
                                                                                            <span className="number">({eachSubCategory.totalItems})</span>
                                                                                        </label>
                                                                                    </div>
                                                                                </li>
                                                                            )
                                                                        })
                                                                    }
                                                                </ul>
                                                            }
                                                        </li>
                                                    )
                                                })
                                            }
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        }

                        { !company?.tags?.useERPCategoryFilterOnBRCP && 
                            <div className="accordion-item" style={{ display: "flex", flexDirection: "column", justifyContent: "left" }}>
                                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "11px" }}>
                                    <h2 className="accordion-header" id="panelsStayOpen-headingOne" style={{ color: "#222", fontSize: "18px", borderBottom: "2px solid #0da487", paddingBottom: "6px" }}>
                                        Categories
                                    </h2>
                                    <i className="pi pi-angle-down" style={{ fontSize: '1rem' }}></i>
                                </div>

                                <div id="collapseOne" className="accordion-collapse collapse show">
                                    <div className="accordion-body">
                                        <div className="form-floating theme-form-floating-2 search-box" style={{ position: "relative", display: "flex", justifyContent: "center" }}>
                                            <input style={{ width: "100%", border: "1px solid #ced4da", borderRadius: "0.25rem" }} type="search" className="form-control" id="search"
                                                placeholder="Search" value={searchCategoryText} onChange={(e) => setSearchCategoryText(e.target.value)}/>

                                            <div style={{ position: "absolute", left: "86%", top: "0.9rem" }}>
                                                <i className="pi pi-search" style={{ fontSize: '1rem' }}></i> 
                                            </div>
                                        </div>
                                        {
                                            selectedCategoryIds.length ? <div className="mt-3" style={{cursor: 'pointer', color: 'rgb(76 140 128)', fontSize: "14px"}} onClick={() => setSelectedCategoryIds([])}>Clear All</div> : null
                                        }
                                        <ul className="category-list custom-padding custom-height pt-1">
                                            {
                                                isLoaderVisible ? 
                                                    renderFilterSkeleton()
                                                :
                                                updatedCategories.map((category) => {
                                                    return (
                                                        <li style={{marginBottom: "0.2rem"}} key={`rc-pm-category-filter-${category.categoryName}`} >
                                                            <div className="form-check ps-0 m-0 category-list-box">
                                                                <input className="checkbox_animated" type="checkbox" id="fruit" onClick={() => handleSelectCategory(category.categoryId)} checked={selectedCategoryIds.includes(category.categoryId)}/>
                                                                <label className="form-check-label" htmlFor="fruit">
                                                                    <span className="name">{capitalizeWordsInValue(category.categoryName)}</span>
                                                                    <span className="number">({category.totalItems})</span>
                                                                </label>
                                                            </div>
                                                        </li>
                                                    )
                                                })
                                            }
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        }

                        <div className="accordion-item mt-5" style={{ display: "flex", flexDirection: "column", justifyContent: "left"}}>
                            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "11px" }}>
                                <h2 className="accordion-header" id="panelsStayOpen-headingOne" style={{ color: "#222", fontSize: "18px", borderBottom: "2px solid #0da487", paddingBottom: "6px" }}>
                                    Brands
                                </h2>
                                <i className="pi pi-angle-down" style={{ fontSize: '1rem' }}></i> 
                            </div>

                            <div id="collapseOne" className="accordion-collapse collapse show">
                                <div className="accordion-body">
                                    <div className="form-floating theme-form-floating-2 search-box" style={{ position: "relative", display: "flex", justifyContent: "center" }}>
                                        <input style={{ width: "100%", border: "1px solid #ced4da", borderRadius: "0.25rem" }} type="search" className="form-control" id="search"
                                            placeholder="Search" value={searchBrandText} onChange={(e) => setSearchBrandText(e.target.value)}/>

                                        <div style={{ position: "absolute", left: "86%", top: "0.9rem" }}>
                                            <i className="pi pi-search" style={{ fontSize: '1rem' }}></i> 
                                        </div>
                                    </div>
                                    {
                                        selectedBrandIds.length ? <div className="mt-3" style={{cursor: 'pointer', color: 'rgb(76 140 128)', fontSize: "14px"}} onClick={() => setSelectedBrandIds([])}>Clear All</div> : null
                                    }
                                    <ul className="category-list custom-padding custom-height pt-1">
                                        {
                                            isLoaderVisible ? 
                                                renderFilterSkeleton()
                                            :
                                            updatedBrands.map((brand) => {
                                                return (
                                                    <li style={{marginBottom: '0.2rem'}}  key={`rc-pm-brand-filter-${brand.brandName}`} >
                                                        <div className="form-check ps-0 m-0 category-list-box">
                                                            <input className="checkbox_animated" type="checkbox" id="fruit" onClick={() => handleSelectBrand(brand.brandId)} checked={selectedBrandIds.includes(brand.brandId)}/>
                                                            <label className="form-check-label" htmlFor="fruit">
                                                                <span className="name">{capitalizeWordsInValue(brand.brandName)}</span>
                                                                <span className="number">({brand.totalItems})</span>
                                                            </label>
                                                        </div>
                                                    </li>
                                                )
                                            })
                                        }
                                    </ul>

                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="catalogue-card-container p-0 col-10" style={{borderLeft: "1px solid #ddd" }}>
                        <div className="catalogue-request buyer-portal-card-container flex flex-wrap ml-3">
                            {
                                isLoaderVisible ? 
                                    renderProductsSkeleton()
                                :
                                <DataView 
                                    value={displayProducts} 
                                    itemTemplate={itemTemplate} 
                                    paginator 
                                    paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport"
                                    currentPageReportTemplate="{first} to {last} of {totalRecords}"
                                    rows={20} 
                                />
                            }
                        </div>
                        <div className="">
                            <Dialog headerStyle={{ padding: "2px" }} header={renderCheckOutHeader} showHeader={true} onHide={() => setVisibleCheckout(false)} className="catalogue-request--cart-dialog custom-scrollbar" visible={visibleCheckout} style={{ width: '80vw', minHeight: '40vh' }} >
                                <Checkout
                                    company={company}
                                    branchId={branchId}
                                    setVisibleCheckout={setVisibleCheckout}
                                    cartItems={cartItems}
                                    updateCartItems={updateCartItems}
                                    handleSubmit={handleSubmit}
                                    cartSubmitRef={cartSubmitRef}
                                    catalogApiRequest={catalogApiRequest}
                                    shippingAddresses={shippingAddresses}
                                    setSelectedShipAddrId={setSelectedShipAddrId}
                                    selectedShipAddrId={selectedShipAddrId}
                                />
                            </Dialog>
                        </div>
                        <Loading visible={isLoaderVisible} />
                        <WishList 
                            isWishListVisible={isWishListVisible} 
                            setIswishListVisible={setIswishListVisible} 
                            products={products}
                            cartItems={cartItems}
                            company={company}
                            setCartItems={setCartItems}
                            updateCartItems={updateCartItems}
                            buyerWishList={buyerWishList}
                            handleWishListChange={handleWishListChange}
                        />
                    </div>
                </div>
            </div>

            <Dialog className="product-view-dialog" visible={isProductViewVisible} style={{ width: "55%", minHeight: "50%" }} onHide={() => { setIsProductViewVisible(false) }} >
                <ProductViewModal
                    viewProductId={viewProductId}
                    materialBrands={materialBrands}
                    materialCategories={materialCategories}
                    products={products}
                    cartItems={cartItems}
                    setCartItems={setCartItems}
                    updateCartItems={updateCartItems}
                    company={company}
                    handleViewProduct={handleViewProduct}
                />
            </Dialog>
        </>
    )
}

export default Ariba